import { PureComponent } from "react";

import yup from "utilities/form/yup";

import { BTAlert } from "commonComponents/btWrappers/BTAlert/BTAlert";
import { BTExternalLink } from "commonComponents/btWrappers/BTExternalLink/BTExternalLink";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    type GridColumn,
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";
import TextTruncate from "commonComponents/utilities/TextTruncate/TextTruncate";

class URLCell extends PureComponent<
    IGridCellRenderProps<string | undefined, GridColumn<string | undefined>>
> {
    render() {
        const { cellValue, column, isInEdit } = this.props;
        return !isInEdit ? (
            <TextTruncate>
                <BTExternalLink href={cellValue || undefined}>{cellValue}</BTExternalLink>
            </TextTruncate>
        ) : (
            <BTAlert
                message={`Unimplemented Edit control:'${column.columnType}', value:${JSON.stringify(
                    cellValue,
                )}`}
                type="warning"
                data-testid="urlUnimplementedEditControl"
            />
        );
    }
}

export const columnURL: IClientGridColumn<string | undefined> = {
    validationSchema: yup.string(), // TODO: maybe yup.string().url()?
    columnType: GridColumnType.url,

    // todo: See if we need to check value in this case because it can come from the user (ex: javascript://badthing)
    Cell: URLCell,
};
